(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pawradise-redesign-home"] && !Shopify.designMode) return;
  try {
    
  function initPawradiseDesign(scope) {
    scope.querySelectorAll('[data-pw-calculator]').forEach((calculator) => {
      if (calculator.dataset.ready) return;
      calculator.dataset.ready = 'true';
      const location = calculator.querySelector('[data-pw-location]');
      const pack = calculator.querySelector('[data-pw-package]');
      const panels = Array.from(calculator.querySelectorAll('[data-pw-panel]'));
      const update = () => {
        const chosen = location.selectedOptions[0];
        let active;
        panels.forEach((panel) => { const matches = panel.dataset.mode === chosen.dataset.mode && panel.dataset.package === pack.value; panel.hidden = !matches; if (matches) active = panel; });
        const variant = active?.querySelector('[data-pw-variant]')?.selectedOptions[0];
        calculator.querySelector('[data-pw-total]').textContent = variant?.dataset.price || '';
        calculator.querySelector('[data-pw-price-book]').href = chosen.dataset.book;
      };
      calculator.addEventListener('change', update);
      calculator.querySelector('[data-pw-filters]').hidden = false;
      calculator.querySelector('[data-pw-quote]').hidden = false;
      update();
    });
  }
  initPawradiseDesign(document);
  document.addEventListener('shopify:section:load', (event) => initPawradiseDesign(event.target));

  } catch(e) { console.error(e); }
})();
})();
